import React, { useMemo } from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import NewReleasesIcon from "@mui/icons-material/NewReleases";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import BlockIcon from "@mui/icons-material/Block";
import { i18n } from "../../translate/i18n";

const SelectOperationalState = ({ value, onChange, className }) => {

    const operationalStates = useMemo(() => [
        {
            id: "new",
            label: i18n.t("whatsappModal.operationalState.new"),
            icon: <NewReleasesIcon style={{ color: "#1976d2", marginRight: 6 }} />
        },
        {
            id: "warmingUp",
            label: i18n.t("whatsappModal.operationalState.warmingUp"),
            icon: <WhatshotIcon style={{ color: "#ff9800", marginRight: 6 }} />
        },
        {
            id: "rest",
            label: i18n.t("whatsappModal.operationalState.rest"),
            icon: <ReportProblemIcon style={{ color: "#9c27b0", marginRight: 6 }} />
        },
        {
            id: "punished",
            label: i18n.t("whatsappModal.operationalState.punished"),
            icon: <BlockIcon style={{ color: "#d32f2f", marginRight: 6 }} />
        }
    ], []);

    const handleChange = (e) => onChange(e.target.value);

    const getSelectedLabel = () => {
        if (!value) return i18n.t("whatsappModal.operationalState.placeholder");
        const s = operationalStates.find((item) => item.id === value);
        return s ? s.label : i18n.t("whatsappModal.operationalState.placeholder");
    };

    return (
        <FormControl
            fullWidth
            margin="dense"
            size="small"
            className={className}
        >
            <Select
                fullWidth
                displayEmpty
                variant="outlined"
                value={value || ""}
                onChange={handleChange}
                MenuProps={{
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    transformOrigin: { vertical: "top", horizontal: "left" },
                    getContentAnchorEl: null,
                }}
                renderValue={getSelectedLabel}
            >
                <MenuItem value="">
                    <em>{i18n.t("whatsappModal.operationalState.none")}</em>
                </MenuItem>

                {operationalStates.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                        <span style={{ display: "flex", alignItems: "center" }}>
                            {item.icon}
                            {item.label}
                        </span>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default SelectOperationalState;
